import { gateway } from "../../../gateway";

export const getQuotes = async ({ authToken, quoteId, status, page, pageSize, includeArchived, archivedOnly, genericToken = false }) => {
  try {
    let uri;

    if (quoteId) {
      uri = `quotes/self/${quoteId}?isGeneric=${genericToken ? true : false}`;
    } else {
      const params = new URLSearchParams();
      if (status != null) params.set("status", status);
      if (page != null) params.set("page", String(page));
      if (pageSize != null) params.set("pageSize", String(pageSize));
      if (includeArchived) params.set("includeArchived", "true");
      if (archivedOnly) params.set("archivedOnly", "true");
      const qs = params.toString();
      uri = `quotes/self/${qs ? `?${qs}` : ""}`;
    }

    const response = await gateway.get(uri, {
      headers: {
        Authorization: `${authToken}`,
      },
    });

    return response.data.data || response.data;
  } catch (error) {
    console.error("Error in obtain quotes", error);
    throw error;
  }
};
